import classNames from "classnames";
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import {
  st,
  Form,
  FormMessage,
  Accordion,
  Button,
  HintView,
  FormControl,
  Message,
  ProductVariantFullDecorator,
  ProductVariantDecorator,
} from "lib/index";
import PaymentProfileProductAttachmentFormSection from "lib/components/PaymentProfileProductAttachmentFormSection";
import { open as openEditPaymentProfileModal } from "modules/settings/EditPaymentProfileModal";
import Hint from "./StepPaymentsHint";
import { stateSelector, updateProduct, validate, save } from "../index";

class ProductVariantFormSection extends React.PureComponent {
  handlePaymentProfileProductAttachmentChange(attachment) {
    const { product_variant, onChange } = this.props;
    const nextAttachments = product_variant.payment_profile_product_attachments
      .concat(
        product_variant.payment_profile_product_attachments.find((a) => a.uuid === attachment.uuid) ? [] : [attachment]
      )
      .map((a) => (a.uuid === attachment.uuid ? attachment : a));
    onChange({
      ...product_variant,
      payment_profile_product_attachments: nextAttachments,
    });
  }

  handleEditPaymentProfileClick(pp, event) {
    event.stopPropagation();
    this.props.onPaymentProfileEditClick(pp);
  }

  renderPaymentProfiles({ marketplace }) {
    const { company, product_variant, errors, name, onBlur, onChange, onPaymentProfileEditClick } = this.props;
    const profiles = company.payment_profiles.filter((pp) => pp.marketplace === marketplace);
    const hasSomeEnabledProfile = profiles.find((pp) => {
      const attachment = product_variant.payment_profile_product_attachments.find(
        (a) => a.payment_profile_id === pp.id
      );
      const isEnabled = attachment ? attachment.active : false;
      return true;
    });
    const canCreate = st.authorize("create", {
      type: "PaymentProfile",
      main_company_id: company.id,
      marketplace,
    });
    return (
      (profiles.length > 0 || canCreate) && (
        <div>
          <h4>
            {!marketplace && I18n.t("papp.products.EditProductView.StepPayments.supplier_profiles_title")}
            {marketplace && I18n.t("papp.products.EditProductView.StepPayments.marketplace_profiles_title")}
          </h4>

          {!hasSomeEnabledProfile && (
            <Message warning visible>
              {!marketplace && I18n.t("papp.products.EditProductView.StepPayments.no_supplier_profiles_warning")}
              {marketplace && I18n.t("papp.products.EditProductView.StepPayments.no_marketplace_profiles_warning")}
            </Message>
          )}

          {profiles.map((pp) => {
            const attachment = product_variant.payment_profile_product_attachments.find(
              (a) => a.payment_profile_id === pp.id
            );
            const attachmentUuid = attachment ? attachment.uuid : `pp-${pp.uuid}`;
            return (
              <PaymentProfileProductAttachmentFormSection
                editable
                key={pp.uuid}
                name={`${name}.payment_profile_product_attachments[${attachmentUuid}]`}
                attachment={attachment}
                errors={errors}
                onBlur={onBlur}
                onChange={this.handlePaymentProfileProductAttachmentChange.bind(this)}
                payment_profile={pp}
                onEditClick={st.authorize("update", pp) && this.handleEditPaymentProfileClick.bind(this, pp)}
              />
            );
          })}

          {canCreate && (
            <Button
              as="a"
              basic
              color="blue"
              size="small"
              className="u-marginTop"
              onClick={() => onPaymentProfileEditClick({ marketplace })}
            >
              <i className="icon material-icons">add</i>{" "}
              {I18n.t("papp.products.EditProductView.StepPayments.add_new_payment_profile")}
            </Button>
          )}
        </div>
      )
    );
  }

  render() {
    const { company, product_variant, errors, name, onBlur, onChange, onPaymentProfileEditClick } = this.props;
    return (
      <div>
        {!!errors[name] && <FormMessage error={errors[name]} />}

        {!!errors[`${name}.payment_profile_product_attachments`] && (
          <FormMessage error={errors[`${name}.payment_profile_product_attachments`]} />
        )}

        {company.enable_saas && (
          <div>
            {this.renderPaymentProfiles({ marketplace: false })}
            <br />
          </div>
        )}
        {this.renderPaymentProfiles({ marketplace: true })}
      </div>
    );
  }
}

@connect(
  (state) => ({
    currentCompany: state.auth.company.model,
    currentCompanyLoading: state.auth.fetchLoading,
    product: stateSelector(state).product,
    submitLoading: stateSelector(state).submitLoading,
    valid: stateSelector(state).valid,
    errors: stateSelector(state).errors,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        updateProduct,
        validate,
        save,
        openEditPaymentProfileModal,
      },
      dispatch
    )
)
export default class StepPaymentsForm extends React.PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      activeIndex: null,
    };
  }
  handleOpenAccordion = (e, { index }) => {
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };

  handleSubmit(event) {
    const { save } = this.props;
    event.preventDefault();
    save();
  }

  handleProductVariantChange(nextProductVariant) {
    const { product, updateProduct } = this.props;
    console.log(product.product_variants);
    console.log(nextProductVariant);
    updateProduct({
      ...product,
      product_variants: product.product_variants.map((x) =>
        x.uuid === nextProductVariant.uuid ? nextProductVariant : x
      ),
    });
  }

  renderProductVariantFormSection(product_variant) {
    const { currentCompany, product, errors, validate, openEditPaymentProfileModal } = this.props;
    const onBlur = validate;

    return (
      <ProductVariantFormSection
        name={`product.product_variants[${product_variant.uuid}]`}
        errors={errors}
        company={currentCompany}
        product_variant={product_variant}
        product={product}
        onBlur={onBlur}
        onChange={this.handleProductVariantChange.bind(this)}
        onPaymentProfileEditClick={(pp) => openEditPaymentProfileModal(pp)}
      />
    );
  }

  _isProductVariantValid(pv) {
    const { errors } = this.props;
    return errors.hasValidProp(`product.product_variants[${pv.uuid}].payment_profile_product_attachments`);
  }

  render() {
    const { product, currentCompanyLoading, submitLoading, valid, errors, validate } = this.props;
    const { activeIndex } = this.state;
    const onBlur = validate;
    const isSupplier = st.authorize.company.id === product.company.id;

    return (
      <HintView.Container>
        <HintView.Content>
          <Form
            className="text"
            onSubmit={this.handleSubmit.bind(this)}
            error={!valid}
            loading={currentCompanyLoading || submitLoading}
          >
            <h1>{I18n.t("papp.products.EditProductView.StepPayments.form_title")}</h1>

            {!!errors.base && <FormMessage error={errors.base} />}

            {isSupplier && (
              <div>
                {product.product_variants.length == 1 &&
                  this.renderProductVariantFormSection(product.product_variants[0])}

                {product.product_variants.length > 1 && (
                  <Accordion
                    exclusive={false}
                    styled
                    fluid
                    defaultActiveIndex={st.range(0, product.product_variants.length)}
                  >
                    {product.product_variants.map((product_variant) => [
                      <Accordion.Title
                        active={activeIndex === product_variant.id}
                        index={product_variant.id}
                        onClick={this.handleOpenAccordion}
                        className={this._isProductVariantValid(product_variant) ? undefined : "title--error"}
                      >
                        {product_variant.name || I18n.t("papp.common.no_name")} <i className="icon dropdown"></i>
                      </Accordion.Title>,
                      <Accordion.Content active={activeIndex === product_variant.id}>
                        {this.renderProductVariantFormSection(product_variant)}
                      </Accordion.Content>,
                    ])}
                  </Accordion>
                )}
              </div>
            )}

            {!isSupplier && (
              <Message warning visible>
                {I18n.t("papp.products.EditProductView.StepPayments.access_temporarily_enabled_only_for_supplier")}
              </Message>
            )}

            <button type="submit" disabled={submitLoading} hidden />
          </Form>
        </HintView.Content>
        <HintView.Sidebar>
          <Hint />
        </HintView.Sidebar>
      </HintView.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepPayments/StepPaymentsForm.jsx